import React, { useState, useEffect, useCallback } from 'react';
import './courses.css';

const Quiz = ({ module, onQuizComplete }) => {
  const quizData = module.quiz;
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);
  const [wrongAnswers, setWrongAnswers] = useState([]);
  
  const getInitialState = () => {
    try {
      const savedProgress = JSON.parse(localStorage.getItem('quizProgress')) || {};
      return savedProgress[module.id] || { attempts: 0, passed: false };
    } catch {
      return { attempts: 0, passed: false };
    }
  };

  const [progress, setProgress] = useState(getInitialState);
  
  const shuffleQuestions = useCallback(() => {
    const questionsArray = [...quizData.questions];
    for (let i = questionsArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [questionsArray[i], questionsArray[j]] = [questionsArray[j], questionsArray[i]];
    }
    setShuffledQuestions(questionsArray);
  }, [quizData.questions]);


  useEffect(() => {
    if (progress.passed) {
      setShowResults(true);
    } else {
      shuffleQuestions();
    }
  }, [progress.passed, shuffleQuestions]);


  const handleAnswerChange = (questionIndex, optionIndex) => {
    setAnswers({
      ...answers,
      [questionIndex]: optionIndex,
    });
  };

  const handleSubmit = () => {
    let newScore = 0;
    const newWrongAnswers = [];

    shuffledQuestions.forEach((q, index) => {
      if (answers[index] === q.correctAnswer) {
        newScore++;
      } else {
        newWrongAnswers.push({
            question: q.question,
            selected: q.options[answers[index]] || "No respondida",
            correct: q.options[q.correctAnswer]
        });
      }
    });

    const finalScore = (newScore / shuffledQuestions.length) * 100;
    const passed = finalScore >= 75;

    setScore(finalScore);
    setWrongAnswers(newWrongAnswers);
    setShowResults(true);

    const newProgress = {
      attempts: progress.attempts + 1,
      passed: passed,
      wrongAnswers: passed ? [] : newWrongAnswers
    };
    
    setProgress(newProgress);
    onQuizComplete(module.id, newProgress);
  };

  const handleRetry = () => {
      setAnswers({});
      setShowResults(false);
      setScore(0);
      setWrongAnswers([]);
      shuffleQuestions();
  }

  if (progress.passed) {
    return (
        <div className="quiz-container quiz-passed">
            <h3>¡Evaluación Aprobada!</h3>
            <p>Has demostrado tu conocimiento en este módulo. ¡Puedes cerrar esta sección y continuar con el siguiente módulo!</p>
        </div>
    )
  }

  if (showResults) {
    return (
      <div className="quiz-container quiz-results">
        <h3>Resultados de la Evaluación</h3>
        <h4>Tu puntuación: {score.toFixed(0)}%</h4>
        {score >= 75 ? (
          <p className="quiz-feedback-success">¡Excelente trabajo! Has aprobado. Ya puedes desbloquear el siguiente módulo.</p>
        ) : (
          <div>
            <p className="quiz-feedback-fail">No has alcanzado la puntuación mínima para aprobar.</p>
            <div className="wrong-answers-section">
                <h4>Repasemos tus respuestas incorrectas:</h4>
                <ul>{wrongAnswers.map((item, index) => (<li key={index}><p><strong>Pregunta:</strong> {item.question}</p><p><em>Tu respuesta:</em> {item.selected}</p><p><em>Respuesta correcta:</em> {item.correct}</p></li>))}</ul>
            </div>
            {progress.attempts < 2 ? (
              <button onClick={handleRetry} className="main-button secondary-button">Intentar de Nuevo (Intento {progress.attempts + 1} de 2)</button>
            ) : (
              <p className="quiz-feedback-fail">Has agotado tus 2 intentos. Por favor, repasa el contenido de las lecciones antes de continuar.</p>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="quiz-container">
      <h3>Validación de Conocimiento</h3>
      <p>Demuestra lo que has aprendido para desbloquear el siguiente módulo.</p>
      <div className="quiz-form">
        {shuffledQuestions.map((q, qIndex) => (
          <div key={qIndex} className="question-block"><p className="question-text">{qIndex + 1}. {q.question}</p><div className="options-group">
              {q.options.map((option, oIndex) => (<label key={oIndex} className="option-label"><input type="radio" name={`question-${qIndex}`} value={oIndex} checked={answers[qIndex] === oIndex} onChange={() => handleAnswerChange(qIndex, oIndex)}/>{option}</label>))}
          </div></div>
        ))}
        <button onClick={handleSubmit} className="main-button primary-button">Entregar Evaluación</button>
      </div>
    </div>
  );
};

export default Quiz;